var _defs, _rect, _path, _path2, _path3, _path4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5e5e5e;opacity:0;}.cls-2{fill:#c00;}.cls-3{fill:#1f1f1f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 180,
    height: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M168.72,15.3l-5.56,10.8A12.54,12.54,0,0,1,172.47,30a13.41,13.41,0,0,1,3.84,9.76,13.51,13.51,0,0,1-23.16,9.39,13.08,13.08,0,0,1-3.88-9.3,14.09,14.09,0,0,1,.6-4,40.36,40.36,0,0,1,2.77-6.21l9.14-17.89Zm-6,18.56a5.05,5.05,0,0,0-3.84,1.66,6.27,6.27,0,0,0,.07,8.33,5.12,5.12,0,0,0,3.8,1.7,5.31,5.31,0,0,0,3.92-1.67,6.22,6.22,0,0,0,.05-8.36A5.32,5.32,0,0,0,162.69,33.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.76,8.46V52.64h-4V47.16a17.54,17.54,0,0,1-5.79,4.72,15.72,15.72,0,0,1-7,1.58,15.52,15.52,0,0,1-11.55-4.91,16.42,16.42,0,0,1-4.79-11.93A16.16,16.16,0,0,1,42.4,24.84,15.76,15.76,0,0,1,54,20a15,15,0,0,1,7.11,1.67,16.08,16.08,0,0,1,5.58,5V8.46ZM54.37,23.9a12.35,12.35,0,0,0-10.93,6.41,12.95,12.95,0,0,0,0,12.88A12.61,12.61,0,0,0,48.09,48a12.15,12.15,0,0,0,6.25,1.71A12.83,12.83,0,0,0,60.72,48a12,12,0,0,0,4.64-4.6A13.14,13.14,0,0,0,67,36.87a12.68,12.68,0,0,0-3.64-9.25A12.07,12.07,0,0,0,54.37,23.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.38,42.07l3.46,1.81a18.56,18.56,0,0,1-3.93,5.39,15.61,15.61,0,0,1-5,3.12,17.36,17.36,0,0,1-6.31,1.07q-7.8,0-12.2-5.11A17.26,17.26,0,0,1,77,36.79,17.08,17.08,0,0,1,80.72,26a15.23,15.23,0,0,1,12.64-6,15.74,15.74,0,0,1,13,6.18A17.3,17.3,0,0,1,109.9,37H81.21a13,13,0,0,0,3.55,9.1,11.32,11.32,0,0,0,8.48,3.55A13.77,13.77,0,0,0,98,48.84a12.61,12.61,0,0,0,3.91-2.25A18.9,18.9,0,0,0,105.38,42.07Zm0-8.59A13.41,13.41,0,0,0,103,28.24a11.25,11.25,0,0,0-4.15-3.17,12.71,12.71,0,0,0-5.42-1.2,11.71,11.71,0,0,0-8.07,3,13.62,13.62,0,0,0-3.73,6.59Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147,27.39l-3.25,2a13.64,13.64,0,0,0-11.5-5.6,13.27,13.27,0,0,0-9.67,3.75,12.21,12.21,0,0,0-3.85,9.1,13,13,0,0,0,1.77,6.56A12.52,12.52,0,0,0,125.34,48a14.71,14.71,0,0,0,18.39-3.9L147,46.23a15.3,15.3,0,0,1-6.14,5.33,19.53,19.53,0,0,1-8.77,1.9,17.34,17.34,0,0,1-12.54-4.8,15.64,15.64,0,0,1-5-11.69,16.63,16.63,0,0,1,2.33-8.6,16.38,16.38,0,0,1,6.4-6.2A18.7,18.7,0,0,1,132.39,20a19.62,19.62,0,0,1,6.11,1,17.16,17.16,0,0,1,5,2.52A13.82,13.82,0,0,1,147,27.39Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20.04,
    y: 9.01,
    width: 11.24,
    height: 11.24,
    rx: 5.49
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20.04,
    y: 25.36,
    width: 11.24,
    height: 11.24,
    rx: 5.49
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20.04,
    y: 40.69,
    width: 11.24,
    height: 11.24,
    rx: 5.49
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.69,
    y: 9.01,
    width: 11.24,
    height: 11.24,
    rx: 5.49
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.69,
    y: 25.36,
    width: 11.24,
    height: 11.24,
    rx: 5.49
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.69,
    y: 40.69,
    width: 11.24,
    height: 11.24,
    rx: 5.49
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "169.15 6.54 158.41 13.3 169.64 19.22 169.15 6.54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.98c53c5f8e0302e3583e7275ca4a4ccb.svg";
export { ForwardRef as ReactComponent };